















































































import Vue from 'vue'
import { Component, Mixin, Lifecycle } from 'av-ts'
import { EventBus } from '@/eventbus'
import { ILesson, languages, ITranslation } from '@/models'
import { notEmpty } from '@/utils'

@Component({
  store: ['user']
})
// export default class Test extends Vue {
export default class Test extends Mixin(EventBus) {
  error = undefined
  lessonName ='New lesson'
  languages = languages
  sourceLanguage = languages[0]
  targetLanguage = languages[1]

  // user?: string

  addForm = {
    srcWord: '',
    tgtWord: ''
  }

  translations = [
    { srcWord: 'to eat', tgtWord: 'manger' },
    { srcWord: 'to eat', tgtWord: 'bouffer' },
    { srcWord: 'a rabbit', tgtWord: 'un lapin' },
  ] as ITranslation[]

  @Lifecycle
  created() {
    console.debug('Test.vue created store=', this.$store)
  }

  addTranslations() {
    const srcList = this.addForm.srcWord.split('/').filter(_ => notEmpty(_)).map(_ => _.trim())
    const tgtList = this.addForm.tgtWord.split('/').filter(_ => notEmpty(_)).map(_ => _.trim())
    console.debug('srcList, tgtList =', srcList, tgtList)
    let tslAdded = false
    if (srcList.length == 1 && tgtList.length == 1) { // common case: 1 word with 1 translation
      tslAdded = this.addTranslation(srcList[0], tgtList[0])
    } else if (srcList.length > 1 && tgtList.length > 1) {
      return EventBus.emitError('Cannot have multiple words and translations at the same time')
    } else if (srcList.length > 1) { // multiple source words with the same translation
      tslAdded = srcList.every(srcWord => this.addTranslation(srcWord, tgtList[0]))
    } else if (tgtList.length > 1) { // multiple translations for the source word
      tslAdded = tgtList.every(tgtWord => this.addTranslation(srcList[0], tgtWord))
    } else {
      return EventBus.emitError(`Unexpected case srcList.length=${srcList.toLocaleString} tgtList.length=${tgtList.length}`)
    }
    
    if (tslAdded) { // in case of error, don't empty fields
      this.addForm.srcWord = ''
      this.addForm.tgtWord = ''
    }
    this.setFocus(this.$refs['srcWordTxtField'])
  }

  private addTranslation(srcWord: string, tgtWord: string) {
    const tsl: ITranslation = { _id: null, srcWord, tgtWord, order: 0 } 
    const index = this.translations.findIndex((item) => item.srcWord === tsl.srcWord && item.tgtWord === tsl.tgtWord)
    if (index != -1) {
      EventBus.emitError(`This translation already exists (${srcWord} -> ${tgtWord}) !`)
      return false
    } else {
      this.translations.push(tsl)
      return true
    }
  }

  removeTranslation(itrans: ITranslation) {
    const index = this.translations.findIndex(_ => _ == itrans)
    if (index == -1)
      EventBus.emitError(`Cannot remove translation ${itrans}, it was not found in list`)
    else
      this.translations.splice(index, 1)
  }

  wordChanged() {
    console.debug('wordChanged arguments=', arguments)
  }

  private setFocus(elm: Vue | Element | Vue[] | Element[]) {
    this.$nextTick(() => (elm as HTMLInputElement).focus())
  }
}
